import { ProContactDeleteConfirmModalQuery } from 'generated/graphql';
import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useMemo,
} from 'react';
import ProContactDeleteConfirmModalView, {
  ProContactDeleteConfirmModalProps,
} from './pro-contact-delete-confirm-modal-view';
import { ContactResponse } from 'generated/api-client';

type ProContactDeleteConfirmModalContainerProps =
  ProContactDeleteConfirmModalProps & {
    contact?: ContactResponse;
    currentProViewId?: number;
    data?: ProContactDeleteConfirmModalQuery;
    loading: boolean;
    onConfirm?: (contactId: number) => void;
    contactId: number;
  };

const ProContactDeleteConfirmModalContainer: FunctionComponent<
  ProContactDeleteConfirmModalContainerProps
> = ({
  data,
  currentProViewId,
  loading,
  onClose,
  onConfirm,
  contactId,
  contact,
  ...rest
}) => {
  const confirmDelete = useCallback(() => {
    if (onConfirm) {
      onConfirm(contactId);
    }
    if (onClose) {
      onClose();
    }
  }, [onClose, onConfirm]);

  const relatedProViewProContacts = useMemo(
    () =>
      data?.relatedProViewProPeople.filter(
        (proView) => proView.id !== currentProViewId,
      ),
    [data?.relatedProViewProPeople],
  );

  const relatedProViewAccounts = useMemo(
    () =>
      data?.relatedProViewAccounts.filter(
        (proView) => proView.id !== currentProViewId,
      ),
    [data?.relatedProViewAccounts],
  );

  const hasCurrentAccountRelated = useMemo(
    () =>
      !!data?.relatedProViewAccounts.find(
        (proView) => proView.id === currentProViewId,
      ),
    [data?.relatedProViewAccounts],
  );

  // If no others related entities linked then auto confirm
  useEffect(() => {
    if (
      relatedProViewProContacts &&
      relatedProViewProContacts.length === 0 &&
      relatedProViewAccounts &&
      relatedProViewAccounts.length === 0
    ) {
      if (onConfirm) {
        onConfirm(contactId);
      }
      if (onClose) {
        onClose();
      }
    }
  }, [relatedProViewProContacts]);

  if (!contact && !loading) {
    return <>Erreur contact introuvable</>;
  }

  // Loading state
  if (!contact || !relatedProViewProContacts) {
    return null;
  }

  return (
    <ProContactDeleteConfirmModalView
      relatedProViewProContacts={relatedProViewProContacts}
      relatedProViewAccounts={relatedProViewAccounts ?? []}
      hasCurrentAccountRelated={hasCurrentAccountRelated}
      contact={contact}
      confirmDelete={confirmDelete}
      onClose={onClose}
      {...rest}
    />
  );
};

export default ProContactDeleteConfirmModalContainer;
